import Module, { moduleInit, subscribeMsg, ViewLayer, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import GameChatView from "./game_chat_view";
import { GameChatModel } from "./game_chat_model";
import GameServer from "../../../hall/server/gameserver/game_server";
import * as ProtoPokerRoom from "../../../table/net/proto/proto_poker_room";
import NetMsgDataBase from "../../../table/net/net_msg_data_table_base";
import { gameChatData } from "./game_chat_data";
import ModelData from "../../../public/model_data";
const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit('GameChat')
export default class GameChat extends Module<GameChatView,GameChatModel> {

    constructor() {
        super();
        this.viewType = ViewLayer.Highest;
        this.windowPrefabResPath = "package/table/game_chat/module/game_chat";
        this.viewType = GameChatView;
        this.modelType = GameChatModel;
        this.clickAnywhereClose = true;
    }

    private initChat:boolean = false;

    onInit(){
        this.view.init(this.clickUIFunc.bind(this));
    }

    onShow(){
        this.model.init(GameServer.instance.netClient);
        this.model.clearMsgEvent()
        this.registerMsg()
        this.initChat = false;
    }

    @subscribeMsg(NetMsgDataBase.ChatNotify)
    ChatMsgBroadcast(data:ProtoPokerRoom.Room.ChatMsgBroadcast){
        cc.warn('msg: ',data);
        let chatMsg = {
            playerId:data.playerId,
            chatMsg:data.chatMsg,
        }
        this.view.appendOne(chatMsg,true);
    }

    @bindButtonClickEvent('sendBtn')
    sendBtn(){
        let str = this.view.editorBox.string;
        if (str.length > 0) {
            this.model.send_chat(3,str)
        }
        this.view.editorBox.string = ''

        cc.error('xxx',gameChatData.getRecentEmotion());
    }

    clickUIFunc(index:number){
        let self = this;
        if (index == 2 && !self.initChat) {
            self.view.setData(gameChatData.chatHistory);
            self.initChat = true;
        }
    }
    
    protected onButtonClickName(name : string, customEventData,_node:cc.Node){
        if (name.startsWith('_quickChat')) {
            let nameNode = _node.getChildByName('name');
            let str = nameNode.getComponent(cc.Label).string;
            //this.view.appendOne(str,true);
            this.model.send_chat(2,str)
        }else if (name.startsWith('em_')) {
            let em = name.split('_')[1];
            let id = ModelData.instance.roleData.id;
            let str = id + '_' + id +'_' + em;
            this.model.send_chat(1,str)
        }
    }
}
